import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterRoleList = () => {
  const listRole = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-role/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { listRole }
}

export default InteractorMasterRoleList
